// centralized location for setting armature and tracker colors

// these should not be changed unless the global colors of the 'bg-' series are changed
const baseColors = {
  'bg-success': '#4dbd74',
  'bg-warning': '#ffc107',
  'bg-dark': '#2f353a',
  'bg-primary': '#20a8d8',
  'bg-danger': '#f86c6b',
  'bg-brown': '#5d4037',
  'bg-secondary': '#c8ced3',
  'bg-purple': '#673ab7'
};

const armColors = {
  healthy: {
    class: 'bg-success',
    color: baseColors['bg-success']
  },
  azimuthError: {
    class: 'bg-danger',
    color: baseColors['bg-danger']
  },
  elevationError: {
    class: 'bg-purple',
    color: baseColors['bg-purple']
  },
  otherError: {
    class: 'bg-brown',
    color: baseColors['bg-brown']
  },
  unknownError: {
    class: 'bg-secondary',
    color: baseColors['bg-secondary']
  }
};

const trackerColors = {
  track: {
    class: 'bg-success',
    color: baseColors['bg-success']
  },
  stow: {
    class: 'bg-warning',
    color: baseColors['bg-warning']
  },
  idle: {
    class: 'bg-dark',
    color: baseColors['bg-dark']
  },
  sleep: {
    class: 'bg-primary',
    color: baseColors['bg-primary']
  },
  error: {
    class: 'bg-danger',
    color: baseColors['bg-danger']
  },
  other: {
    class: 'bg-brown',
    color: baseColors['bg-brown']
  },
  unknown: {
    class: 'bg-secondary',
    color: baseColors['bg-secondary']
  }
};

const colorDecoder = {
  armature(status) {
    return armColors[status].class;
  },
  tracker(mode) {
    return trackerColors[mode].class;
  }
};

export {
  armColors,
  trackerColors,
  colorDecoder
};
